import styled, { css } from 'styled-components';

export const SideTitle = styled.div`
  align-items: center;
  background: ${props => props.theme.sideEventBg};
  border-radius: 6px;
  width: 100%;
  margin: 0px 20px 10px 20px;
  padding: .5rem;
`;

export const SideLogContainer = styled.div`
  position: relative;
  width: 350px;
  min-height: 200px;
  margin: 0px 20px 10px 20px;
  padding: 1rem;
  background: #122441;
  border-radius: 10px;
  font-size: 14px;
  overflow-y: auto;
  display: flex;

  & > div.title {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background: ${props => props.theme.sideEventBg};
    border-radius: 4px;
    width: 45px;

    & > div > svg {
      cursor: pointer;
      margin-top: 15px;
      width: 25px;
      height: 25px;
    }
  }

  & > div.content {
    height: 175px;
    overflow-y: auto;

    & > div.none_data {
      width: 255px;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
`